import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    banners: {
      finalPaymentNoticeDismissed: false,
    },
  },
  reducers: {
    setFinalPaymentNoticeDismissed: (
      state,
      action: PayloadAction<{ [key: string]: boolean }>,
    ) => {
      return {
        ...state,
        banners: {
          finalPaymentNoticeDismissed:
            action.payload.finalPaymentNoticeDismissed,
        },
      };
    },
  },
});

export default uiSlice.reducer;

export const selectFinalPaymentNoticeDismissed = (state: {
  uiReducer: { banners: { [key: string]: boolean } };
}) => state.uiReducer.banners.finalPaymentNoticeDismissed;
